/** @jsxImportSource @emotion/react */
"use client";

import { HallowAnalyticsEvent, useAnalytics } from "@packages/analytics";
import {
  matchSelectableGuide,
  useCurrentQueueItem,
  usePlayer,
} from "@packages/media";
import type { Track } from "@packages/sdk";
import { useCallback } from "react";

import { useMediaAnalyticsProps } from "../../../../hooks/useMediaAnalyticsProps";
import { SelectLengthList } from "./SelectLengthList.emotion";

export const SelectLengthContent = () => {
  const { currentItem } = useCurrentQueueItem();
  const player = usePlayer();
  const { track } = useAnalytics();
  const analyticsProps = useMediaAnalyticsProps();

  const handleSetSelectedLength = useCallback(
    (
      option:
        | Partial<Track>
        | ((prev: Partial<Track> | null) => Partial<Track>),
    ) => {
      const newOption = typeof option === "function" ? option(null) : option;
      if (newOption.media_type === currentItem.selected_audio.media_type) {
        void track({
          event: HallowAnalyticsEvent.ChangedLength,
          properties: {
            ...analyticsProps,
            length: option.length,
          },
        });
      } else {
        void track({
          event: HallowAnalyticsEvent.ChangedMediaType,
          properties: analyticsProps,
        });
      }
      void player.switchTo(newOption);
    },
    [player, track, currentItem, analyticsProps],
  );

  if (currentItem?.type === "radio_song") return null;

  const currentGuide = currentItem?.prayer?.selectable_guides?.find((g) =>
    matchSelectableGuide(g.guide_ids, currentItem.selected_audio.guide_ids),
  );

  const lengths = currentGuide.tracks;

  return (
    <SelectLengthList
      selectedLength={currentItem?.selected_audio}
      setSelectedLength={handleSetSelectedLength}
      options={lengths}
    />
  );
};
